import React, { useEffect } from 'react';
import { 
  Box, 
  Container, 
  Heading, 
  Text, 
  VStack, 
  Button, 
  Icon, 
  useColorModeValue 
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FiCheckCircle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useSetAtom } from 'jotai';
import { fetchSubscriptionAtom } from '../../../atoms/v0/subscriptionAtoms';
import { PageLayout } from '../../../components/v0/PageLayout';

/**
 * 支付成功页面
 * 当用户完成订阅支付后，Stripe将重定向到此页面
 */
const SubscriptionSuccess: React.FC = () => {
  const { t } = useTranslation(['v0/subscription', 'v0/common']);
  const fetchSubscription = useSetAtom(fetchSubscriptionAtom);
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const cardBg = useColorModeValue('white', 'gray.800');
  
  // 在组件挂载时获取最新的订阅信息
  useEffect(() => {
    // 延迟一秒再获取数据，确保Stripe webhook有时间处理
    const timer = setTimeout(() => {
      fetchSubscription();
    }, 1000);
    
    return () => clearTimeout(timer);
  }, [fetchSubscription]);
  
  return (
    <PageLayout title={t('v0/subscription:success.pageTitle')}>
      <Box bg={bgColor} minH="calc(100vh - 64px)" py={10}>
        <Container maxW="container.md">
          <VStack
            spacing={8}
            bg={cardBg}
            p={10}
            borderRadius="lg"
            boxShadow="md"
            align="center"
            textAlign="center"
          >
            <Icon as={FiCheckCircle} w={20} h={20} color="green.500" />
            
            <Heading as="h1" size="xl">
              {t('v0/subscription:success.title')}
            </Heading>
            
            <Text fontSize="lg">
              {t('v0/subscription:success.message')}
            </Text>
            
            <Text color="gray.500">
              {t('v0/subscription:success.detail')}
            </Text>
            
            <VStack spacing={4} pt={4}>
              <Button 
                as={RouterLink} 
                to="/subscription" 
                colorScheme="primary" 
                size="lg"
              >
                {t('v0/subscription:success.viewSubscription')}
              </Button>
              
              <Button 
                as={RouterLink} 
                to="/" 
                variant="outline"
              >
                {t('v0/common:actions.backToHome')}
              </Button>
            </VStack>
          </VStack>
        </Container>
      </Box>
    </PageLayout>
  );
};

export default SubscriptionSuccess; 